// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thumbnail[data-v-55e0be58] {\n  width: 100%;\n  border-radius: 4px;\n}", ""]);
// Exports
module.exports = exports;
